export default "__VITE_PUBLIC_ASSET__25d89aa0__"